/**
 * Abstract component class
 *
 * @abstract
 * @class
 */
export default class Component {

	/**
	 * @constructor
	 * @param {HTMLElement} element
	 * @param {Object} data
	 */
	constructor(element, data) {
		/** @type {HTMLElement} */
		this.el = element;
		/** @type {Object} */
		this.data = data;
		/** @type {Array} */
		this.listeners = [];
		this.setupListeners();
	}

	/**
	 * Component events
	 * @return {Object}
	 *
	 * Format:
	 *  - "type": "handlerName"
	 *  - "type<space>.selector": "handlerName"
	 */
	get events() {
		// Example:
		// return {
		// 	'click .example-child': 'handleClick'
		// }
	}

	addEventListener(element, type, listener) {
		this.listeners.push({element, type, listener});
		element.addEventListener(type, listener);
	}

	setupListeners() {
		let events = this.events;
		for (let event in events) {
			let type = event.trim();
			let selector = null;

			// Callback
			let callback = events[event];
			if (typeof callback === 'string') {
				const method = callback;
				callback = (event, element) => this[method](event, element);
			}
			const listener = function (event) {
				callback(event, this);
			};

			// Selector
			const parts = type.match(/^(\S+)\s+(.+)$/);
			if (parts) {
				[, type, selector] = parts;
			}

			// Get target elements
			const targets = selector ? Array.from(this.el.querySelectorAll(selector)) : [this.el];
			if (targets.length === 0) {
				throw new Error(`No target element for event found: ${event}`);
			}


			// Add event listener to each target
			targets.forEach((element) => {
				this.addEventListener(element, type,listener);
			});
		}
	}

	removeAllListeners() {
		this.listeners.forEach((data) => {
			data.element.removeEventListener(data.type, data.listener);
		});
	}

	destroy() {
		this.removeAllListeners();

		for (let prop in this) {
			this[prop] = null;
		}
	}

};
